const bannerSize = [
    { label: 'Full width', value: 'full_width' },
    { label: 'Contained', value: 'contained' },
    { label: 'Short width', value: 'short_width' },
];

export default bannerSize;
